import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, of, timer } from 'rxjs';
import { catchError, repeat, switchMap } from 'rxjs/operators';

import { SessionBindingInfo } from '@ap/interface-apic-authenticatie-fido';
import { TaskStatus } from '@ap/interface-apic-authenticatiebeheer';

import { ApTokenService } from '../token.service';

@Injectable()
export class ApNativeAppService {
    private readonly tokenService = inject(ApTokenService);

    /**
     * Gets the authentication status.
     *
     * @param actionId The action id.
     * @param refreshTime The refresh time.
     * @return actionStatus The action status.
     */
    public pollAuthenticationStatus(actionId: string, refreshTime: number): Observable<TaskStatus> {
        return this.tokenService.getAuthenticationStatus(actionId).pipe(repeat({ delay: refreshTime }));
    }

    /**
     * Gets the challenge.
     *
     * @param actionId The action id.
     * @param refreshTime The refresh time.
     * @return challenge The challenge.
     */
    public pollChallenge(actionId: string, refreshTime: number): Observable<SessionBindingInfo | HttpErrorResponse> {
        return timer(0, refreshTime).pipe(switchMap(() => this.tokenService.getChallenge(actionId).pipe(catchError((e) => of(e)))));
    }

    /**
     * Unbinds the challenge from other devices such that FEP can take over the session in order to show a new QR code.
     *
     * @param actionId The action id.
     * @return challenge The challenge.
     */
    public unbindChallenge(actionId: string): Observable<SessionBindingInfo> {
        return this.tokenService.unbindChallenge(actionId);
    }
}
